import React, { useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { uploadDocument } from "services/documents";
import { useToast } from "components/Toast";
import { useNavigate } from "react-router-dom";

const CreateDocument = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) {
      toast.showError("Please select a file");
      return;
    }
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("title", title);
      fd.append("file", file);
      await uploadDocument(fd);
      navigate("/admin/documents");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to upload document");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Upload Document</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="mt-1 block w-full rounded-md border-gray-300 bg-white text-gray-900 placeholder-gray-400 shadow-sm dark:border-white/10 dark:bg-navy-800 dark:text-white dark:placeholder-white/40"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            File
          </label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            required
            className="mt-1 block w-full text-gray-900 dark:text-white"
          />
        </div>
        <div>
          <Button type="submit" disabled={submitting}>
            {submitting ? "Uploading..." : "Upload"}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default CreateDocument;
// (placeholder removed; real component exported above)
